import { mediumPassRegex } from "helpers/validators.js";

export const ResetPasswordFields = {
  Password: {
    fieldKey: "Password",
    element: "input",
    type: "password",
    title: "password",
    label: "reset-password-label",
    placeholder: "reset-password-label",
    validation: {
      required: true,
      invalidMessage: "signin-password-medium-tooltip-text",
      reg: mediumPassRegex,
    },
    showPasswordStrength: true,
    //containerClassName: "input",
  },
  ConfirmPassword: {
    fieldKey: "ConfirmPassword",
    element: "input",
    type: "password",
    title: "confirmPassword",
    label: "reset-password-confirm-label",
    placeholder: "reset-password-confirm-label",
    hidePassStrength: true,
    validation: {
      required: true,
      invalidMessage: "signin-password-medium-tooltip-text",
      reg: mediumPassRegex,
    },
    //containerClassName: "input",
  },
};
